import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="bg-slate-100 px-4 py-6 md:px-12 md:py-8" data-id="element-162" data-mp="20qnmhm6g4bn0">
      <h2 className="mx-auto max-w-[600px] text-center text-[22px] font-extrabold uppercase leading-[1.25] tracking-[-0.3px] text-blue-950 md:text-[30px]" data-id="element-163" data-mp="1myzcbofrbx8o">
        Lo que dicen los profesionales
      </h2>
      <div className="mt-3 space-y-2.5" data-id="element-164" data-mp="1d0t9n4m4mn2r">
        {testimonials.map(t => <figure key={t.name} className="rounded-md border border-slate-200 bg-white px-3.5 py-3 md:px-4" data-id="element-165" data-mp="1i1h2lvtx1dzm">
            <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-166" data-mp="141y7c3m7dx4q">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-amber-400 text-amber-400" aria-hidden data-id="element-167" data-mp="1831l8kkoxj3b" data-mpi={i} />)}
            </div>
            <blockquote className="mt-1.5 text-[14px] leading-[1.45] text-slate-600 md:text-[15px]" data-id="element-168" data-mp="32gso918il4ps">“{t.quote}”</blockquote>
            <figcaption className="mt-2" data-id="element-169" data-mp="2v0svtc9usa4y">
              <span className="block text-[12px] font-extrabold uppercase text-blue-950" data-id="element-170" data-mp="2uzrlja0nvroa">
                {t.name}, {t.age} años
              </span>
              <span className="block text-[12px] leading-snug text-slate-600" data-id="element-171" data-mp="34rx8g5c23iwm">{t.role}</span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}